// Array.prototype.flatMap() polyfill
if (!Array.prototype.flat) {
	Object.defineProperty(Array.prototype, "flat", {
		value: function(callback, thisArg) {
			return this.reduce((a, b) => a.concat(b), []);
		},
		configurable: true,
		writable: true
	});
}

// Array.prototype.flatMap() polyfill
if (!Array.prototype.flatMap) {
	Object.defineProperty(Array.prototype, "flatMap", {
		value: function(callback, thisArg) {
			return this.map(callback, thisArg).reduce((a, b) => a.concat(b), []);
		},
		configurable: true,
		writable: true
	});
}
